export enum SelectionDisplayStatus {
  Suspended = 'suspended',
  Closed = 'closed',
  Open = 'open',
}

export enum MarketStatus {
  Open = 'Open',
  Suspended = 'Suspended',
  Closed = 'Closed',
}

export enum CashOutStatus {
  Open = 'Open',
  Suspended = 'Suspended',
  Closed = 'Closed',
}

export enum SelectionStatus {
  Unpriced = 'Unpriced',
  Trading = 'Trading',
  Suspended = 'Suspended',
  NonRunner = 'NonRunner',
}

export enum SelectionResultStatus {
  None = 'None',
  Winner = 'Winner',
  Pushed = 'Pushed',
  Loser = 'Loser',
  Placed = 'Placed',
  Partial = 'Partial',
}

export enum EventStatusType {
  Notstarted = 'Notstarted',
  Inprogress = 'Inprogress',
  Finished = 'Finished',
  Cancelled = 'Cancelled',
  Postponed = 'Postponed',
}

export enum BetSlipResultStatus {
  Won = 'Won',
  Lost = 'Lost',
  Voided = 'Voided',
}

export enum BetSlipType {
  Single = 'Single',
  Multiple = 'Multiple',
  System = 'System',
  Chained = 'Chained',
  Ways = 'Ways',
}

export enum SystemBetTypesEnum {
  BxMul2L = 'BXMUL-2L',
  BxMul3L = 'BXMUL-3L',
  BxMul4L = 'BXMUL-4L',
  BxMul5L = 'BXMUL-5L',
  BxMul6L = 'BXMUL-6L',
  BxMul7L = 'BXMUL-7L',
  BxMul8L = 'BXMUL-8L',
  BxMul9L = 'BXMUL-9L',
  BxMul10L = 'BXMUL-10L',
  BxMul11L = 'BXMUL-11L',
  BxMul12L = 'BXMUL-12L',
  BxMul13L = 'BXMUL-13L',
  BxMul14L = 'BXMUL-14L',
  BxMul15L = 'BXMUL-15L',
  BxMul16L = 'BXMUL-16L',
  Patent = 'PATENT',
  Lucky15 = 'LUCKY15',
  Lucky31 = 'LUCKY31',
  Lucky63 = 'LUCKY63',
  Trixie = 'TRIXIE',
  Yankee = 'YANKEE',
  SupYankee = 'SUPYANKEE',
  Heinz = 'HEINZ',
  SupHeinz = 'SUPHEINZ',
  Goliath = 'GOLIATH',
}
